import type { TypographyProps } from '@components/ui/Typography'
import { Typography } from '@components/ui/Typography'

import { CircularProgress } from '../CircularProgress'

import { WrapperDiv } from './styles'

type CenteredPageLoaderProps = Pick<TypographyProps, 'children'>

export function CenteredPageLoader({ children }: CenteredPageLoaderProps) {
  return (
    <WrapperDiv $gap={30}>
      <div>
        <CircularProgress size={50} />
      </div>
      <Typography size="400-lg">{children}</Typography>
    </WrapperDiv>
  )
}
